import React, { useState, useEffect, useRef } from "react";
import LayoutHOC from "../LayoutHOC";
import { Link, useNavigate } from "react-router-dom";
import CustomerHome from "./CustomerHome";
import CustomerOtherDetail from "./CustomerOtherDetail";
import CustomerReportingTeam from "./CustomerReportingTeam";
import CustomerServices from "./CustomerServices";
import AddTask from "./AddTask";
import AddNotes from "./notes/index";
import { useParams } from "react-router-dom";
import { CUSTOMER_DETAILS_DATA, NODE_URL, NODE_URL_V2 } from "../../utils/constants";
import { useDispatch } from "react-redux";
import { getCommonDataBasedOnId } from "../store/customer/CustomerSocialAddUpdateFunction";
import ManageAccess from "./ManageAccess";
import { ReactComponent as AddCustoHomeIcn } from "../../assets/images/addCustoHomeIcn.svg";
import { useSidebar } from "../../components/SidebarContext";
import { pushAlert } from "../../utils/alertSlice";
import { getUserToken } from "../../utils/utilityFunctions/localServices";
import CustomerDocument from "./Documents/CustomerDocument";
import { ReactComponent as DownArrow } from "../../assets/images/downArrow.svg";
import { ReactComponent as ExpanIcon } from "../../assets/images/icons/expalndIcon.svg";
import CustomerDelegation from "./CustomerDelegation";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import BillingDashboard from "./Billings/BillingDashboard";
import CustomDashboard from "./CustomModule/CustomDashboard";
import { getTitleCase } from "../../utils/utilityFunctions/stringUtility";
import FloatingElement from "../UniversalComponents/FloatingElement";

function isValidJson(string) {
  try {
    JSON.parse(string);
    return true; // The string is valid JSON
  } catch (error) {
    return false; // The string is not valid JSON
  }
}

const componentList = {
  CustomerHome: CustomerHome,
  CustomerOtherDetail: CustomerOtherDetail,
  CustomerReportingTeam: CustomerReportingTeam,
  CustomerServices: CustomerServices,
  TaskModule: AddTask,
  ProjectModule: AddTask,
  CustomerNotes: AddNotes,
  ManageAccess: ManageAccess,
  CustomerDocument: CustomerDocument,
  BillingDashboard: BillingDashboard,
  CustomerDelegation: CustomerDelegation,
  CustomModule: CustomDashboard,
};

console.log("checking Full Screent", NODE_URL, NODE_URL_V2);

const AddCustomer1 = () => {
  const navigate = useNavigate();
  const { id: customerId, tab: tabValue, leadTypePath: subTabValue } = useParams();

  const [customerGData, setCustomerGData] = useState([]);
  const [customer, setCustomer] = useState(false);
  const [customerGroupName, setCustomerGroup] = useState();
  const [customerType, setCustomerType] = useState();
  const [cusnameletter, setnameletter] = useState();
  const [refetch, setRefetch] = useState(false);
  const [expendedSide, setExpandedSide] = useState(false);
  const [myTabsGrouped, setMyTabsGrouped] = useState([]);
  const [activeHoverSection, setActiveHoverSection] = useState(null);

  const sidebarContext = useSidebar();

  // for setting Header Props
  const setheaderProps = sidebarContext?.setheaderProps;
  const setExpandSideBar = sidebarContext?.setExpandSideBar;

  useEffect(() => {
    if (customer || customerGroupName || customerType || cusnameletter) {
      setheaderProps({
        name: customer,
        groupname: isValidJson(customerGroupName) ? JSON.parse(customerGroupName) : customerGroupName,
        type: customerType,
        pt: "0px",
        icon: <AddCustoHomeIcn />,
        url: "/customers",
        nameletter: cusnameletter,
      });
      setExpandSideBar(false);
    }
    return () => {
      setheaderProps(null);
      setExpandSideBar(true);
    };
  }, [customer, customerGroupName, customerType, cusnameletter]);

  const fetchCustomerData = async () => {
    try {
      const response = await getCommonDataBasedOnId(`${CUSTOMER_DETAILS_DATA}${customerId}`, getUserToken());

      setCustomerGData(response);

      const customerName = response?.data[0]?.customer_data[0].customer_name;
      setCustomer(customerName);
      const cutomergroup = response?.data[0]?.customer_data[0].customer_group;
      setCustomerGroup(cutomergroup);
      const ctype = response?.data[0]?.customer_data[0].type;
      setCustomerType(ctype);
      const words = customerName?.split(" "); // Split the string into an array of words
      const firstLetter = words[0] ? words[0][0] : ""; // Get the first letter of the first word
      const secondLetter = words[1] ? words[1][0] : ""; // Get the first letter of the second word
      const nameletter = firstLetter + secondLetter;

      setnameletter(nameletter);

      if (response?.success || response?.data?.success || response?.data?.status) {
        const sideBarResponse = await getCommonDataBasedOnId(
          `${NODE_URL_V2}global/get-template-config?parent_id=2a7e7e5f-939e-11f0-b592-bc2411f4d589&customer_id=${customerId}`,
          getUserToken()
        );
        setMyTabsGrouped(sideBarResponse);
      } else {
        dispatch(pushAlert({ message: response?.message, type: "danger", visible: true }));
      }
    } catch (err) {
      dispatch(pushAlert({ message: "Something went wrong", type: "danger", visible: true }));
    } finally {
    }
  };

  useEffect(() => {
    fetchCustomerData();
  }, [customerId, refetch]);

  const dispatch = useDispatch();

  const [menuState, setMenuState] = useState({});

  const handleMenuToggle = (clickedItem) => {
    setMenuState((prev) => ({
      ...prev,
      [clickedItem.value]: !prev[clickedItem.value],
    }));
  };

  useEffect(() => {
    if (!tabValue && myTabsGrouped.length) {
      // If no tab is present, redirect to general_information
      let firstSection = myTabsGrouped[0];
      console.log("acccessssss", firstSection);
      if (firstSection?.items) {
        navigate(`/customer/${customerId}/${firstSection.value}/${firstSection.items[0].value}`, { replace: true });
      } else {
        navigate(`/customer/${customerId}/${firstSection.value}`, { replace: true });
      }
    }
  }, [myTabsGrouped, tabValue]);

  const [collapsedGroups, setCollapsedGroups] = useState({});

  const toggleGroup = (title) => {
    setCollapsedGroups((prev) => ({
      // ...prev,
      [title]: !prev[title],
    }));
  };

  const section = myTabsGrouped?.find((section) => section.value === tabValue);

  const PageComponent = section?.items
    ? section?.items?.find((item) => item.value === subTabValue)?.component
    : section?.component;

  const PageContent = componentList[PageComponent];

  if (!myTabsGrouped.length) {
    return <div className="w-full h-full flex justify-center items-center">Loading...</div>; // or a spinner, or null
  }
  return (
    <div className={`px-2 pb-0 bg-[#fff] sticky h-full pt-1`}>
      <div className={`flex h-full gap-3`}>
        <div
          className={`bg-white border-b border-l border-r flex flex-col  shadow-[0px_2.667px_2.667px_rgba(0,0,0,0.05)] transition-[width] duration-200  ${expendedSide ? "min-w-[250px]" : "w-[50px]"} h-full`}
        >
          <div className="h-10 bg-primary-20 w-full flex justify-end items-center px-4 border-b ">
            <ExpanIcon
              width={"28px"}
              onClick={() => setExpandedSide((prev) => !prev)}
              className={`transition-transform duration-200 ${expendedSide ? "rotate-0" : "rotate-180"}`}
            />
          </div>
          <div className="grow min-h-0 overflow-y-auto overflow-hidden thinscrollbar bg-primary-active flex flex-col gap-y-2 px-2 py-2">
            {myTabsGrouped.map((section, index) =>
              expendedSide ? (
                <div key={index} className="last:border-none">
                  <Link
                    className={`flex items-center justify-between px-3 py-2 group tracking-wide cursor-pointer text-sm rounded-lg 
                    ${
                      section.value === tabValue
                        ? "text-white bg-primary font-600 hover:bg-primary hover:text-white"
                        : "hover:bg-primary-hover hover:text-primary text-[#667C8A] font-500"
                    }`}
                    onClick={() => toggleGroup(section.title)}
                    to={
                      section.items
                        ? `/customer/${customerId}/${section.value}/${section.items[0].value}`
                        : `/customer/${customerId}/${section.value}`
                    }
                  >
                    <div className="flex gap-2 items-center justify-between">
                      {" "}
                      {/* <section.icons width={"20px"} fill={section.value === tabValue ? "#365573" : "#667C8A98"} /> */}
                      <i
                        className={`${section.icon} text-xl ${section.value === tabValue ? "text-white" : "group-hover:text-primary text-[#667C8A98]"} transition-colors duration-200  `}
                      />
                      <span>{getTitleCase(section.title)}</span>
                    </div>
                    {console.log("section.items lalala", section)}
                    {section.items && (
                      <span
                        className={`self-center ml-4 mr-2 transition-transform duration-200 ${
                          collapsedGroups[section.title] ? "rotate-180 text-[#383838CC]" : "rotate-0 text-[#666] "
                        }`}
                        // onClick={(e) => {e.stopPropagation(); toggleGroup(section.title)}}
                      >
                        <DownArrow fill={section.value === tabValue ? "#ffffff" : "#667C8A98"} />
                      </span>
                    )}
                  </Link>

                  {/* Section Items (collapsible) */}
                  {section.items && collapsedGroups[section.title] && (
                    <div className="flex flex-col ml-5">
                      {section.items
                        .filter((item) => !item.checkAccess || item.access)
                        .map((tab, i) => (
                          <div key={i} className="relative ">
                            <Link
                              className={`flex items-center gap-2  py-2  px-3 cursor-pointer text-sm   border-l-2 rounded-r-md
                                ${
                                  subTabValue === tab.value && section.value === tabValue
                                    ? "bg-primary-active text-[#666] font-500 border-primary "
                                    : "text-[#666] font-400 border-[#D2DAE1] hover:bg-primary-hover"
                                }`}
                              to={
                                tab.defaultSubTab
                                  ? `/customer/${customerId}/${tab.value}/${tab.defaultSubTab}`
                                  : `/customer/${customerId}/${section.value}/${tab.value}`
                              }
                              onClick={() => handleMenuToggle(tab)}
                              role="tab"
                            >
                              <div className="flex justify-between">
                                <p
                                  className={`whitespace-nowrap flex items-center gap-2 ${
                                    subTabValue === tab.value && section.value === tabValue
                                      ? "text-primary font-semibold "
                                      : "text-[#666] font-normal"
                                  }`}
                                >
                                  {getTitleCase(tab.label)}
                                </p>
                              </div>
                            </Link>
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              ) : (
                <div
                  key={index}
                  className="last:border-none w-full group relative"
                  onMouseEnter={() => setActiveHoverSection(section.title)}
                  onMouseLeave={() => setActiveHoverSection(null)}
                >
                  <ToolTipComponent
                    text={section.title}
                    placement="right"
                    darkMode
                    disable={Boolean(section?.items && !section?.is_custom_module)}
                  >
                    <Link
                      className={`flex items-center justify-center text-base font-500 tracking-wide cursor-pointer  
              `}
                      to={
                        section.items
                          ? `/customer/${customerId}/${section.value}/${section.items[0].value}`
                          : `/customer/${customerId}/${section.value}`
                      }
                    >
                      {/* ${section.value === tabValue ? "bg-primary text-[#383838] font-600" : "text-[#666] font-500"} */}
                      {/* <section.icons width={"20px"} fill={section.value === tabValue ? "text-[#fff]" : "text-[#667C8A99]}
                                            style ={{}}
                                            /> */}
                      <i
                        className={`${section.icon} flex items-center justify-center text-xl p-2 rounded-md transition-colors duration-200 ${
                          section.value === tabValue
                            ? "text-[#fff] bg-primary hover:bg-primary hover:text-[#fff]"
                            : "text-[#667C8A99] hover:bg-primary-hover hover:text-primary"
                        }`}
                      />
                    </Link>
                  </ToolTipComponent>

                  {section.items && !section?.is_custom_module && activeHoverSection === section.title && (
                    <FloatingElement margin={0}>
                      <div className=" ml-3 bg-primary-lightest px-2 py-1 rounded">
                        <p className={`whitespace-nowrap flex items-center gap-2 text-primary font-semibold text-sm`}>
                          {section.title}
                        </p>
                        {section.items
                          .filter((item) => !item.checkAccess || item.access)
                          .map((tab, i) => (
                            <div key={i} className="relative ">
                              <Link
                                className={`flex items-center gap-2  py-2  px-2 ml-1 cursor-pointer text-sm   border-l-2 rounded-r-md
                                ${
                                  subTabValue === tab.value && section.value === tabValue
                                    ? "bg-primary-active text-[#666] font-500 border-primary "
                                    : "text-[#666] font-400 border-[#D2DAE1] hover:bg-primary-hover"
                                }`}
                                to={
                                  tab.defaultSubTab
                                    ? `/customer/${customerId}/${tab.value}/${tab.defaultSubTab}`
                                    : `/customer/${customerId}/${section.value}/${tab.value}`
                                }
                                onClick={() => handleMenuToggle(tab)}
                                role="tab"
                              >
                                <div className="flex justify-between">
                                  <p
                                    className={`flex items-center gap-2 truncate max-w-[20ch]  ${
                                      subTabValue === tab.value && section.value === tabValue
                                        ? "text-primary font-semibold "
                                        : "text-[#666] font-normal"
                                    }`}
                                  >
                                    {getTitleCase(tab.label)}
                                  </p>
                                </div>
                              </Link>
                            </div>
                          ))}
                      </div>
                    </FloatingElement>
                  )}
                </div>
              )
            )}
          </div>
        </div>

        <div className={` h-full flex flex-col grow min-w-0 `}>
          <div className="no-scrollbar overflow-y-auto h-full   shadow-[0_4px_6px_-4px_rgba(0,0,0,0.15)] ">
            <div className="relative flex flex-col min-w-0 break-words h-full rounded " id={`tab-${tabValue}`}>
              <div className="flex-auto grow min-h-0 ">
                <div className="tab-content tab-space h-full">
                  {PageContent ? (
                    <PageContent
                      customerGData={customerGData}
                      type={section.type ? section.type : ""}
                      leadType={section.value === "my-assignment" ? "project" : "task"}
                      subNavitems={section?.items}
                      setRefetch={setRefetch}
                      customerId={customerId}
                      propTemplateId={section?.module_uuid}
                      fullScreen={section?.is_custom_module}
                    />
                  ) : (
                    <div>No Content Found</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayoutHOC(AddCustomer1);
